import { useTranslation } from 'react-i18next';
import { string } from 'yup';

import { COMMON_TRANSLATION } from '@constants/index';
import { USER_FORM_MAX_LENGTH } from '../constants';
import { UseUserFieldsValidationValue } from './useUserFieldsValidation.types';

export const useUserFieldsValidation = (): UseUserFieldsValidationValue => {
  const { t } = useTranslation(COMMON_TRANSLATION);

  const firstName = string()
    .required(
      t('form.errors.required', {
        ns: COMMON_TRANSLATION,
        label: t('first_name'),
      }),
    )
    .max(
      USER_FORM_MAX_LENGTH.FIRST_NAME,
      t('form.errors.max_length', {
        ns: COMMON_TRANSLATION,
        label: t('first_name'),
        max: USER_FORM_MAX_LENGTH.FIRST_NAME,
      }),
    );

  const lastName = string()
    .required(
      t('form.errors.required', {
        label: t('last_name'),
      }),
    )
    .max(
      USER_FORM_MAX_LENGTH.LAST_NAME,
      t('form.errors.max_length', {
        label: t('last_name'),
        max: USER_FORM_MAX_LENGTH.LAST_NAME,
      }),
    );

  const email = string()
    .email(t('form.errors.email_format'))
    .required(
      t('form.errors.required', {
        label: t('email'),
      }),
    )
    .max(
      USER_FORM_MAX_LENGTH.EMAIL,
      t('form.errors.max_length', {
        label: t('email'),
        max: USER_FORM_MAX_LENGTH.EMAIL,
      }),
    );

  const phoneNumber = string()
    .required(
      t('form.errors.required', {
        label: t('phone_number'),
      }),
    )
    .trim()
    .min(
      12, // Number of characters including spaces and special characters of formatting
      t('form.errors.phone_min_length', {
        label: t('phone_number'),
        min: USER_FORM_MAX_LENGTH.MIN_PHONE_NUMBER,
        max: USER_FORM_MAX_LENGTH.MAX_PHONE_NUMBER,
      }),
    )
    .max(
      14, // Number of characters including spaces and special characters of formatting, max set to 15 to account for country code: 2-456-890-2345)
      t('form.errors.phone_max_length', {
        label: t('phone_number'),
        min: USER_FORM_MAX_LENGTH.MIN_PHONE_NUMBER,
        max: USER_FORM_MAX_LENGTH.MAX_PHONE_NUMBER,
      }),
    );

  return {
    firstName,
    lastName,
    email,
    phoneNumber,
  };
};
